/**
 * Eagerly load every markdown doc as a raw string at build time and key it by
 * slug (filename without extension). Vite inlines the content, so no runtime
 * fetch or second deploy artifact is needed.
 */
const modules = import.meta.glob('./content/*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>;

const bySlug: Record<string, string> = {};
for (const [path, raw] of Object.entries(modules)) {
  const slug = path.replace(/^.*\/([^/]+)\.md$/, '$1');
  bySlug[slug] = raw;
}

export function getDocContent(slug: string): string | undefined {
  return bySlug[slug];
}
